import React, { useState } from "react";

// Import images
import MooseHunt from "./QftFF/Images/Level1/1_MooseHunt.png";
import BloodseekerNest from "./QftFF/Images/Level1/2_BloodseekerNest.png";
import AttackOnGreenMoon from "./QftFF/Images/Level1/3_AttackOnGreenMoon.png";

import Outset from "./QftFF/Images/Level2/1_Outset.png";
import Gremlins from "./QftFF/Images/Level2/2_Gremlins.png";
import Kelpie from "./QftFF/Images/Level2/3_Kelpie.png";
import AncientBattlefield from "./QftFF/Images/Level2/4_AncientBattlefield.png";
import WizardAboveRedCatCave from "./QftFF/Images/Level2/5_WizardAboveRedCatCave.png";
import RogueRedCatCave from "./QftFF/Images/Level2/6_RogueRedCatCave.png";
import RedCatCaveSpirit from "./QftFF/Images/Level2/7_RedCatCaveSpirit.png";

const QftFFEncounters = () => {
  // Define captions for each encounter
  const captions = {
    "1_MooseHunt.png":
      "Garrick gets his feelings hurt by the giant moose's intimidation because he is the only party member that can understand him.",
    "2_BloodseekerNest.png":
      "The party lets Flumbus take the lead on clearing the bloodseeker nest to get some bomb throwing practice.  However, the mosquitos swarm him and deal some serious damage.",
    "3_AttackOnGreenMoon.png":
      "The party fends off an attack from the Burning Mammoths on the Night of the Green Moon during their ceremony of officially joining the tribe.",
    "1_Outset.png":
      "The party begins their journey east with the tribe as official members.",
    "2_Gremlins.png":
      "Confident that Flumbus can handle the batterfoot's merciless beating, Aiddeon charges after the other gremlins.",
    "3_Kelpie.png":
      "The party faces off against a kelpie at the tribe's usual lake spot.",
    "4_AncientBattlefield.png":
      "A mysterious scarecrow terrorizes and long abandoned weapons attack on their own at an ancient battlefield.",
    "5_WizardAboveRedCatCave.png":
      "A big game hunter wizard nearly nukes Garrick and Enor with a fireball scroll above Red Cat Cave.",
    "6_RogueRedCatCave.png":
      "The party explores Red Cat Cave and faces off against a rogue from the Darklands",
    "7_RedCatCaveSpirit.png":
      "Quelling the ancient Cat Spirit that guarded the Primordial Flame",
  };

  const encounters = [
    { src: MooseHunt, caption: captions["1_MooseHunt.png"], level: 1 },
    {
      src: BloodseekerNest,
      caption: captions["2_BloodseekerNest.png"],
      level: 1,
    },
    {
      src: AttackOnGreenMoon,
      caption: captions["3_AttackOnGreenMoon.png"],
      level: 1,
    },
    { src: Outset, caption: captions["1_Outset.png"], level: 2 },
    { src: Gremlins, caption: captions["2_Gremlins.png"], level: 2 },
    { src: Kelpie, caption: captions["3_Kelpie.png"], level: 2 },
    {
      src: AncientBattlefield,
      caption: captions["4_AncientBattlefield.png"],
      level: 2,
    },
    {
      src: WizardAboveRedCatCave,
      caption: captions["5_WizardAboveRedCatCave.png"],
      level: 2,
    },
    {
      src: RogueRedCatCave,
      caption: captions["6_RogueRedCatCave.png"],
      level: 2,
    },
    {
      src: RedCatCaveSpirit,
      caption: captions["7_RedCatCaveSpirit.png"],
      level: 2,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const getLevelStarts = () => {
    const starts = {};
    encounters.forEach((encounter, index) => {
      if (!starts[encounter.level]) {
        starts[encounter.level] = index;
      }
    });
    return starts;
  };

  const levelStarts = getLevelStarts();

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % encounters.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + encounters.length) % encounters.length
    );
  };

  const currentEncounter = encounters[currentIndex];

  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        background: "linear-gradient(to bottom, #dee2e6, #f8f9fa)",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          color: "#2c3e50",
          fontFamily: "serif",
          marginBottom: "30px",
          textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
        }}
      >
        Quest For the Frozen Flame Encounters
      </h1>
      <div style={{ marginBottom: "20px" }}>
        {Object.keys(levelStarts).map((level) => (
          <button
            key={level}
            onClick={() => setCurrentIndex(levelStarts[level])}
            style={{
              margin: "0 10px",
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor:
                encounters[currentIndex].level === parseInt(level)
                  ? "#3498db"
                  : "#ecf0f1",
              color:
                encounters[currentIndex].level === parseInt(level)
                  ? "#ffffff"
                  : "#2c3e50",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "bold",
              transition: "background-color 0.3s ease",
            }}
          >
            Level {level}
          </button>
        ))}
      </div>
      <div
        style={{
          position: "relative",
          width: "800px",
          height: "600px",
          margin: "0 auto",
          borderRadius: "10px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          background: "#ffffff",
        }}
      >
        <button
          onClick={prevSlide}
          style={{
            position: "absolute",
            left: "-60px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "48px",
            background: "none",
            border: "none",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          ‹
        </button>
        <img
          src={currentEncounter.src}
          alt={currentEncounter.caption}
          onClick={nextSlide}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            cursor: "pointer",
            display: "block",
          }}
        />
        <button
          onClick={nextSlide}
          style={{
            position: "absolute",
            right: "-60px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "48px",
            background: "none",
            border: "none",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          ›
        </button>
      </div>
      <p
        style={{
          marginTop: "20px",
          fontSize: "18px",
          color: "#34495e",
          fontWeight: "bold",
        }}
      >
        Level {currentEncounter.level}: {currentEncounter.caption}
      </p>
      <div style={{ marginTop: "30px" }}>
        {encounters.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrentIndex(index)}
            style={{
              display: "inline-block",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: index === currentIndex ? "#3498db" : "#bdc3c7",
              margin: "0 8px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              boxShadow:
                index === currentIndex
                  ? "0 0 8px rgba(52, 152, 219, 0.5)"
                  : "none",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default QftFFEncounters;
